import axios from 'axios';
import { ResponseAPIWithPagination } from "../../../common/types/API.types";
import { PlanBT, PlanBTFilter, PlanBTPatch, Pole, PolePatch } from '../types/planBT.types';
import { FileDtoIn } from '../../../common/types/files.types';
import { FileUrl } from '../../../common/components/molecule/FileListManager/FileListManager';
import { convertFileToFileDto } from '../../../common/utils/fileReader';
import { NodePlan } from '../types/node.types';
import { LinkPlan } from '../types/link.types';

const BACKEND_URL = process.env.REACT_APP_BACKEND_API_URL+'/api/v1';


export const getAllPlanBT = async (currentPage: number, pageSize: number, filter?: PlanBTFilter) => {

    const params =  "currentPage=" + currentPage + "&pageSize=" + pageSize;
    const filterParams = "&orderByQuery=-plan_updated_at" + (filter?.querySearch ? "&query=" + filter.querySearch : "")

    return (await axios.get<ResponseAPIWithPagination<PlanBT>>(`${BACKEND_URL}/planbt?${params}${filterParams}`)).data;

}

export const getPlanBTById = async (id: string) => {
    return (await axios.get<PlanBT>(`${BACKEND_URL}/planbt/${id}`)).data;
}



export const createPlanBT = async (plan: PlanBTPatch, file?: FileUrl) => 
{
    if (!file) {
        return (await axios.post<PlanBT>(`${BACKEND_URL}/planbt`, plan)).data;
    }

    const fileList : FileDtoIn[]  | undefined = await convertFileToFileDto([file]) 

    const planBT = (await axios.post<PlanBT>(`${BACKEND_URL}/planbt`, plan)).data;


    return (await axios.post<PlanBT>(`${BACKEND_URL}/planbt/${planBT.plan_id}/images`, fileList[0])).data;
}

export const updatePlanBT = async (planId: string ,plan: PlanBTPatch, files?: FileUrl ) => {
  
    const fileList : FileDtoIn[]  | undefined =files ? await convertFileToFileDto([files]) : undefined
    const file = fileList?.[0] || null;
    if (file && !file.ignore) {
        const result = await axios.post<PlanBT>(`${BACKEND_URL}/planbt/${planId}/images`, file);
        plan.plan_image_file_id = result.data.plan_image_file_id;
    }
    if (!file ){
        plan.plan_image_file_id = "";
    }
    return (await axios.put<PlanBT>(`${BACKEND_URL}/planbt/${planId}`, plan)).data;

}

export const uploadImageToPlanBT = async (file: FileDtoIn, planId: string) => {
    return (await axios.post<PlanBT>(`${BACKEND_URL}/planbt/${planId}/images`, file)).data;
}

export const deletePlanBT = async (planId: string) => {
    return (await axios.delete<PlanBT>(`${BACKEND_URL}/planbt/${planId}`)).data;
}

export const addPoleToPlanBT = async (planId: string,newPole: PolePatch) => {
    return (await axios.post<Pole>(`${BACKEND_URL}/planbt/${planId}/poles`, newPole)).data;
}

export const GetAllPolesFromPlanBT = async (planId: string, query?: string) => {

    return (await axios.get<ResponseAPIWithPagination<Pole>>(`${BACKEND_URL}/planbt/${planId}/poles?orderByQuery=-pole_updated_at`+( (query && query !== "")  ? ("&query="+query) : '' ))).data;
}



export const getSinglePoleFromPlanBT = async (planId: string, poleId: string) => {
    return (await axios.get<Pole>(`${BACKEND_URL}/planbt/${planId}/poles/${poleId}`)).data;
}

export const deletePoleFromPlanBT = async (planId: string, poleId: string) => {
    return (await axios.delete<Pole>(`${BACKEND_URL}/planbt/${planId}/poles/${poleId}`)).data;
}

export const updateSinglePoleFromPlanBT = async (planId: string, poleId: string, pole: PolePatch) => {
    return (await axios.put<Pole>(`${BACKEND_URL}/planbt/${planId}/poles/${poleId}`, pole)).data;
}

export const getAllNodeFromPlanBT = async (planId: string) => {
    return (await axios.get<ResponseAPIWithPagination<NodePlan>>(`${BACKEND_URL}/planbt/${planId}/nodes`)).data;
}

export const getBaseURLNodePlanBT = (planId: string) => {
    return `${BACKEND_URL}/planbt/${planId}/nodes`;
}

// Inscrit automatiquement les compteurs localisés du minigrid relié au plan comme
// noeuds du plan (idempotent cote backend, sans verrou geoloc "manuel").
export const syncMinigridMeters = async (planId: string) => {
    return (await axios.post<{ added: number; skipped: number }>(`${BACKEND_URL}/planbt/${planId}/sync-minigrid-meters`)).data;
}

export const createNode= async (planId: string, node : Partial<NodePlan>) => {
    return (await axios.post<NodePlan>(`${BACKEND_URL}/planbt/${planId}/nodes`, node)).data;
}

export const updateNode= async (planId: string, nodeId: string, node : Partial<NodePlan>) => {
    return (await axios.put<NodePlan>(`${BACKEND_URL}/planbt/${planId}/nodes/${nodeId}`, node)).data;
}

export const deleteNode= async (planId: string, nodeId: string) => {
    return (await axios.delete<unknown>(`${BACKEND_URL}/planbt/${planId}/nodes/${nodeId}`)).data;
}

export const createLink = async (planId: string, link : Partial<LinkPlan>) => {
    return (await axios.post<LinkPlan>(`${BACKEND_URL}/planbt/${planId}/links`, link)).data;
}

export const updateLink = async (planId: string, linkId: string, link : Partial<LinkPlan>) => {
    return (await axios.put<LinkPlan>(`${BACKEND_URL}/planbt/${planId}/links/${linkId}`, link)).data;
}

export const deleteLink = async (planId: string, linkId: string) => {
    return (await axios.delete<unknown>(`${BACKEND_URL}/planbt/${planId}/links/${linkId}`)).data;
}

export const planBTAPI = {
    getAllPlanBT,
    getPlanBTById,
    createPlanBT,
    uploadImageToPlanBT,
    updatePlanBT,
    deletePlanBT,
    addPoleToPlanBT,
    GetAllPolesFromPlanBT,
    getSinglePoleFromPlanBT,
    deletePoleFromPlanBT,
    updateSinglePoleFromPlanBT,
    getAllNodeFromPlanBT,
    createNode,
    updateNode,
    deleteNode,
    createLink,
    updateLink,
    deleteLink,
    syncMinigridMeters
}